import React from 'react';
import { FormattedMessage } from 'react-intl';

/**
 * This Component creates Header (with main and additional text) for every page
 */
const GenericHeader = props => {
    const {
        additionalElement,
        additionalElementClassName,
        additionalElementStyle,
        auxClassName,
        auxText,
        headerClassName,
        linkClassName,
        outerClassName,
        tagClassName,
        id,
        tag: Tag,
        text,
        textReplacements = {},
        auxTextReplacements = {},
        isReplacementALink,
        path,
        linkText
    } = props;

    return (
        <div className={`grid-row ${outerClassName && outerClassName.join(' ')}`}>
            <div className={`${headerClassName}`} id={id}>
                <Tag className={tagClassName && tagClassName.join(' ')}>
                    { !isReplacementALink ?
                        <FormattedMessage
                            id={text}
                            values={ textReplacements }
                        />
                        : <FormattedMessage
                            id={text}
                            values={{
                                textReplacements,
                                link:(
                                    <a
                                        className={`${linkClassName && linkClassName.join(' ')}`}
                                        href={path}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FormattedMessage id={linkText}/>
                                    </a>
                                )
                            }}
                        />
                    }
                    &nbsp;
                    {
                        auxText && (
                            <span className={`${auxClassName}`}>
                                <FormattedMessage
                                    id={auxText}
                                    values={auxTextReplacements}
                                />
                            </span>
                        )
                    }
                </Tag>
            </div>

            {
                additionalElement && (
                    <div className="mobile:grid-col-12 tablet:grid-col-auto">
                        <span
                            className={additionalElementClassName}
                            style={additionalElementStyle}
                        >
                            { additionalElement }
                        </span>
                    </div>
                )
            }
        </div>

    );
};

export default GenericHeader;